const stateroomsRules = ({ data }) => {
  const rules = {
    rooms: ["required", "positive_integer"],
  };

  if (data.resedential_rate_required) {
    rules.rate = ["required", "string", { min_length: 1 }];
  }

  return rules;
};

export default stateroomsRules;
